import { safeboxClient } from 'myNet'

const ROUTE = '/v1/actions'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface ActivityRequest {
  [key: string]: any
}

const ActivityService = {
  post: async (request: ActivityRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default ActivityService
